export function parseJSONString(jsonString, fallback = {}) {
    try {
        return JSON.parse(jsonString);
    }
    catch (error) {
        console.error("Invalid JSON string:", error);
        return fallback;
    }
}
